import { registerPlugin } from '@capacitor/core';

const MtbPlugin = registerPlugin<IMtbPlugin>('Mtb');

export interface IMtbPlugin {
    generate(options: { mtb: string; kid: string; k: string; app: string }): Promise<{ mtb: string }>;

    deviceId(): Promise<{ deviceId: string }>;
}

export default MtbPlugin;
